import { render } from "./AdminEditFilm.vue?vue&type=template&id=612cf36b&scoped=true"
import script from "./AdminEditFilm.vue?vue&type=script&lang=js"
export * from "./AdminEditFilm.vue?vue&type=script&lang=js"

import "./AdminEditFilm.vue?vue&type=style&index=0&id=612cf36b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612cf36b"]])

export default __exports__